Directives.FileCommentsContainerDirective = function FileCommentsContainerDirective() {

    // @ngInject
    function FileCommentsContainerDirectiveControllerFunc(ModalService, UiPersistenceService, WorkspacesManager, $timeout) {
        var self = this;
        this.$timeout     = $timeout;
        this.ModalService = ModalService;
        this.WorkspacesManager = WorkspacesManager;
        this.UiPersistenceService = UiPersistenceService;
        this.persistenceHash = this.UiPersistenceService.getUiPersistence(this.UiPersistenceService.keys.dontShowFileCommentsTooltip) || false;
        this.hasComment = null;

        this.Hash = function Hash() {
            return Math.random().toString(36).slice(2);
        };

        this.register(this.fileModel, 'success', this.gotWorkspaceFile);

        this.hideTooltip = function hideTooltip() {
            this.showFileCommentsTooltip = false;
        };

        if (!this.hideDrawerMethod) {
            this.hideDrawerMethod = function hideDrawerMethod() {
                this.hideDrawerProperty = false;
            };
        }

        if (!this.persistenceHash || !this.persistenceHash['dontShow']) {
            this.showFileCommentsTooltip = true;
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.dontShowFileCommentsTooltip, {'dontShow': true});
            $timeout(function() {
                    self.hideTooltip();
                }, 10000
            );
        } else {
            this.showFileCommentsTooltip = false;
        }
        
        this.$timeout(function() {
            self.shadow = true;
        }, 2000);
    }

    var FileCommentsContainerDirectiveController = Class(Controllers.BaseController, {
        constructor: FileCommentsContainerDirectiveControllerFunc,

        scrollToBottom: function scrollToBottom(speed) {
            var container      = angular.element('#js-file-comments-container');
            var comments       = angular.element('#js-file-comments');
            var commentsHeight = comments.height();

            if (commentsHeight > container.height()) {
                container.animate({scrollTop: commentsHeight}, speed);
            }
        },

        toggleDrawer: function toggleDrawer() {
            if (this.showFileCommentsTooltip) {
                this.hideTooltip();
            }

            this.showCommentsDrawer = !this.showCommentsDrawer;

            if (this.showCommentsDrawer) {
                var el = angular.element('#js-submit-comment-textarea');
                var scrollToBottom = this.scrollToBottom; // "this" context

                this.$timeout(function() {
                    scrollToBottom('fast');
                });

                if (el) {
                    this.$timeout(function() {
                        el.focus();
                    });
                }
            }
        },

        hideDrawerMethod: function hideDrawer() {
            this.showCommentsDrawer = false;
        },

        gotWorkspaceFile: function gotWorkspaceFile() {
            this.workspace = this.WorkspacesManager.getWorkspace(this.fileModel.couple_card_id, true);
            this.hasComment = this.fileModel.feed && this.fileModel.feed.feed_items.length;

            if (!this.alreadyGotFile) {
                this.showCommentsDrawer = this.hasComment;
            }

            this.alreadyGotFile = true;

        }

    });

    return {
        scope: {
            fileModel: '=fileModel'
        },
        templateUrl: 'angular/app/modules/core/features/workspace_file/file_comments/file_comments_container_directive_template.html',
        controller: FileCommentsContainerDirectiveController,
        controllerAs: 'commentsContainerVm',
        bindToController: true
    };
};